import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-padel-tournament-factsheet',
  templateUrl: './padel-tournament-factsheet.component.html',
  styleUrls: ['./padel-tournament-factsheet.component.scss']
})
export class PadelTournamentFactsheetComponent implements OnInit {
  
  public downloadModal: boolean = true;
  position: 'left' | 'right' | 'top' | 'bottom' | 'center' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';

  constructor() { }

  ngOnInit(): void {
  }

}
